import { hideLoading } from '@tencent/wphk-act-base-ui';
import { request } from '@tencent/ppd-base-libs';
import { setRequest } from '@tencent/wphk-act-base-cgi';
import { axios } from '@tencent/wphk-base-request';
import { handlePromLogin } from '@tencent/wphk-act-base-components';

// 注入axios至base-lib
request.init(axios);
// 注入request到cgi
setRequest(request);

handlePromLogin({
  // 业务标识：跳转 self_operate registerUid 页时作为 ?channel= 透传包名，
  // 由 self_operate 的 BUSINESS_CHANNEL_MAP 反查注册渠道（fstandby4，cross-travel→21）。
  business: process.env.VUE_APP_PKGNAME,
  /** 登陆前的处理 */
  beforeLogin() {
    // 执行登陆操作前的处理，如关闭loading等，没有的话可不处理
    hideLoading();
  },
});
